import { safeLocal } from "@/lib/storage";
import { hasFunctionalConsent } from "@/lib/consent/consent";
import { isAppContext } from "@/lib/appContext";

const VISITOR_KEY = "fs_visitor_id";
const INTERNAL_KEY = "fs_internal";

/** Anonymous, stable visitor id. Minted on first read; not linked to identity. */
export function getVisitorId(): string {
  if (isAppContext()) return "anonymous";
  const ls = safeLocal();
  if (!ls) return "anonymous";
  let id = ls.getItem(VISITOR_KEY);
  if (!id) {
    // FIV-499: never mint a persistent visitor id without Functional consent.
    if (!hasFunctionalConsent()) return "anonymous";
    id =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `v-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
    ls.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function isInternal(): boolean {
  const ls = safeLocal();
  return !!ls && ls.getItem(INTERNAL_KEY) === "1";
}

/** Visiting any URL with ?_internal=1 marks this browser as internal traffic. */
export function captureInternalFromUrl(): void {
  if (typeof window === "undefined") return;
  const ls = safeLocal();
  if (!ls) return;
  if (new URLSearchParams(window.location.search).get("_internal") === "1") {
    ls.setItem(INTERNAL_KEY, "1");
  }
}
